import React from 'react'
import Link from '../Link/index'
import GaiaLogo, { TYPE_WHITE } from '../GaiaLogo/index'
import { URL_HOME } from '../../services/url/constants'

/**
 * The header for logged in user
 * @param {Object} props - The props
 * @param {String} props.userReferralId - The user referral id
 * @param {String} props.shareId - The id of share object
 * @returns {JSX.Element} Header
 */

function SharePageHeader (props) {
  const {
    userReferralId,
    shareId,
  } = props

  const query = {}
  if (userReferralId) {
    query.rfd = userReferralId
    query.source = 'SHARE'
    if (shareId) {
      query.sourceId = shareId
    }
  }

  return (
    <header className="share-page__header">
      <Link to={URL_HOME} query={query}>
        <GaiaLogo type={TYPE_WHITE} />
      </Link>
    </header>
  )
}

export default SharePageHeader
